export const AUTH_USER = "AUTH_USER";
export const UPDATE_FUEL = "UPDATE_FUEL";
export const UPDATE_ADDRESS = "UPDATE_ADDRESS";

export const RESET_AUTH = "RESET_AUTH";
export const LOGOUT_USER = "LOGOUT_USER";
export const LOGIN_POPUP_UPDATE = "LOGIN_POPUP_UPDATE";
